/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockSupplierPopupCtrl
 */
angular.module('mercury.modules.stock.supplier')
.controller('StockSupplierPopupCtrl', ["$filter", "onAdd", "$q", "$scope", "StockMasterSuppliers", "StockSuppliers", "$timeout", function($filter, onAdd, $q, $scope, StockMasterSuppliers, StockSuppliers, $timeout) {
  $scope.selected = null;
  $scope.edit = false;

  $scope.supplierFilter = {name: ''};

  $scope.supplier = {};
  $scope.form = {};

  $scope.suppliers = StockSuppliers.getAll();
  $scope.masterSuppliers = StockMasterSuppliers.getAll();

  $scope.loading = $q.all([$scope.suppliers.$promise, $scope.masterSuppliers.$promise]);
  $scope.loading.then(function() {
    var existingMasterSuppliers = [];
    angular.forEach($scope.suppliers, function(supplier) {
      if (supplier.masterId) {
        existingMasterSuppliers.push(supplier.masterId);
      }
    });

    $scope.masterSuppliers = $filter('filter')($scope.masterSuppliers, function(masterSupplier) {
      return existingMasterSuppliers.indexOf(masterSupplier.id) == -1;
    });
  });

  $scope.setSelected = function(selectedSupplier) {
    $scope.selected = selectedSupplier;
  };

  /**
  * Called back for 'Add From Prefered List' auto complete. Add the selected master supplier to the site list then close the popup
  */
  $scope.addPreferedSupplier = function(masterSupplier) {
    if (masterSupplier) {
      $scope.supplier = angular.copy(masterSupplier);
      $scope.supplier.masterId = masterSupplier.id;
      delete $scope.supplier.id;
    } else {
      $scope.supplier = {};
    }
  };

  /**
  * Create a new supplier within the database
  */
  $scope.create = function() {
    $scope.form.supplierAddForm.$setSubmitted();
    if ($scope.form.supplierAddForm.$invalid) {
      return;
    }

    StockSuppliers.create($scope.supplier)
    .then(function(result) {
      $scope.edit = false;

      onAdd(result);
      $scope.suppliers.unshift(result);
      $scope.selected = result;

      $timeout(function() {
        $('#supplierList').animate({
          scrollTop: $('#supplier_' + result.id).offset().top
        }, 500);
      });

      //Reset the model incase they add another.
      $scope.supplier = {};
    });
  };
}]);
